module.exports = __webpack_public_path__ + "img/support.2a0c49d1.svg";